<template>
    <div class="row main-content">
        <div class="col-md-2 ">
            <sidebar>My Tools</sidebar>

        </div>
        <div class="my-tools col-md-10">

            <div>

                <h3>Corporate Branding & Identity</h3>
                <ul>
                    <li>
                        <figure><!-- PIPwestchesterlogolockupsmall.png -->
                            <img
                                src="/archive/my-tools/PIP-Global-Safety-Logo-Color.png"
                                alt="my-tools-icon"
                                style="width: 100%; height: auto;"
                            />
                        </figure>
                        <form>
                            <admin-select  @change="onChange($event)">
                                <option value="?" style="display:none;">Logos</option>
                                <option value="/docs/Logo/PIP-Global-Safety-Logos.zip">&bull; Download Logos</option>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-letterhead.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">Letterhead</option>
                                <option
                                    value="/docs/Letterhead/PIP-Global-Safety-Letterhead-Template.docx"
                                    >&bull; PIP Global Safety Letterhead</option
                                >
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-email-sig.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">Email Signature</option>
                                <option value="/EmailSignature">&bull; Create Your Own</option>

                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-presentation.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Powerpoint</option
                                >
                                <option value="/archive/my-tools/PIP_Global_Safety_AM-R_Template.pptx" >&bull; Preloaded PIP Retail Deck</option>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-wallpaper.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Wallpaper</option
                                >
                                <option value="/archive/my-tools/PIP-Retail-Safety-USA-Teams-Background-01.jpg" >&bull; PIP Retail Background v1</option>
                                <option value="/archive/my-tools/PIP-Retail-Safety-USA-Teams-Background-02.jpg" >&bull; PIP Retail Background v2</option>
                                <option value="/archive/my-tools/PIP-Retail-Safety-USA-Teams-Background-03.jpg" >&bull; PIP Retail Background v3</option>
                            </admin-select>
                        </form>
                    </li>
                </ul>
                <br />
                <br />
                <h3>BRAND LOGOS AND COLLATERAL</h3>
                <ul class="brand">
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/Logo-Boss-Red.png"
                                alt="my-tools-icon"
                                width="100px"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">BOSS</option>
                                <option value="/docs/Logo/Boss-Logos.zip">&bull; Download BOSS Logos</option>
                                <optgroup label="--Collateral (catalogs)--" style="color:#999;">
                                    <option
                                        value="/docs/catalogs/Boss/2025-Boss-Catalog.pdf"
                                        style="color:#666"
                                        >&bull; 2025 Boss Catalog</option
                                    >
                                    <option
                                        value="/docs/Catalogs/Boss/Winter-Sport-Catalog.pdf"
                                        style="color:#666"
                                        >&bull; Boss Winter Sport Catalog</option
                                    >
                                    <option
                                        value="https://pipusa.sharepoint.com/:x:/s/WCPG/ERJSL6Sj_xJOlolPfHwBqZEBvuunPzdDDAeSA2psUOzCtA"
                                        style="color:#666"
                                        >&bull; 2023 Boss Glove Cross Reference</option
                                    >
                                </optgroup>
                                <optgroup label="--Sell Sheets--" style="color:#999;">
                                    <option
                                        value="/docs/catalogs/Boss/Boss Cut Glove booklet.pdf"
                                        style="color:#666"
                                        >&bull; Boss Cut Glove Booklet</option
                                    >
                                    <option
                                        value="/docs/catalogs/Boss/PIP-Boss-High-Dexterity-Gloves-Booklet-final.pdf"
                                        style="color:#666"
                                        >&bull; Boss PIP High Dexterity Gloves Booklet</option
                                    >
                                </optgroup>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/PIP_ProSafetyLogo.png"
                                alt="my-tools-icon"
                                width="100px"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">PIP Pro Safety</option>
                                <option value="/docs/Logo/PIP_Pro_Safety_Logos.zip">&bull; Download PIP Pro Safety Logos</option>
                                <optgroup label="--Collateral (catalogs)--" style="color:#999;">
                                    <option
                                        value="/docs/catalogs/pipprosafety/2025-PIPProSafety-Catalog.pdf"
                                        style="color:#666"
                                        >&bull; 2025 PIP Pro Safety Catalog</option
                                    >
                                </optgroup>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/sw-logo.png"
                                alt="my-tools-icon"
                                width="100px"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">Safety Works</option>
                                <option value="/docs/Logo/Safety-Works-Professional-Logo.zip">&bull; Download Safety Works Logos</option>
                                <optgroup label="--Collateral (catalogs)--" style="color:#999;">
                                    <option
                                        value="/docs/Catalogs/SW/SW-Product-Catalog.pdf"
                                        style="color:#666"
                                        >&bull; Safety Works Product Catalog</option
                                    >
                                </optgroup>
                                <optgroup label="--Sell Sheets--" style="color:#999;">
                                    <option
                                        value="/docs/SellSheets/10068529-Sell-Sheet.pdf"
                                        style="color:#666"
                                        >&bull; 10068529-Sell-Sheet</option
                                    >
                                    <option
                                        value="/docs/SellSheets/SW46001-Sell-Sheet.pdf"
                                        style="color:#666"
                                        >&bull; SW46001-Sell-Sheet</option
                                    >
                                    <option
                                        value="/docs/SellSheets/SWX00478-Sell-Sheet.pdf"
                                        style="color:#666"
                                        >&bull; SWX00478-Sell-Sheet</option
                                    >
                                    <option
                                        value="/docs/SellSheets/2021-Safety-Works-Cone-Sell-Sheet.pdf"
                                        style="color:#666"
                                        >&bull; 2021 Safety Works Cone Sell Sheet</option
                                    >
                                </optgroup>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/mud-logo.png"
                                alt="my-tools-icon"
                                 width="100px"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">Mud</option>
                                <option value="/docs/Logo/Mud-Logo.zip">&bull; Download Mud Logos</option>
                                <optgroup label="--Collateral (catalogs)--" style="color:#999;">
                                    <option value="/archive/my-tools/2025-Mud-Catalog-lowres.pdf" style="color:#666;">&bull; 2025 Mud Catalog</option>
                                    <option value="/archive/my-tools/Mud-Assortment-Catalog-No-Pricing.pdf" style="color:#666;">&bull; Mud Assortment Catalog</option>
                                    <option value="/archive/my-tools/Mud-Assortment-Catalog-No-MSRP.pdf" style="color:#666;">&bull; Mud Assortment Catalog - No MSRP</option>
                                </optgroup>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/WestCounty-Gardener.jpg"
                                alt="my-tools-icon"
                                 width="130px"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">West County Gardener</option>
                                <option value="/docs/Logo/West-County-Gardener-Logo.zip">&bull; Download West County Gardener Logos</option>
                                <option disabled style="color:#999;">--Collateral (catalogs)--</option>
                                <option  value="/docs/Catalogs/2023-West-County-Gardener-Catalog.pdf">&bull; 2023 West County Gardener Catalog</option>

                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/hearos-logo.png"
                                alt="my-tools-icon"
                                width="130px"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">Hearos</option>
                                <option value="/docs/Logo/Hearos-Logo.zip">&bull; Download Hearos Logos</option>
                                <optgroup label="--Collateral (catalogs)--" style="color:#999;">
                                    <option  value="/docs/2023-Hearos-Catalog.pdf" style="color:#666;">&bull; 2023 Hearos Catalog</option>
                                </optgroup>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/smg-logo.png"
                                alt="my-tools-icon"
                                width="130px"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">Scotts Miracle-Gro</option>
                                <option value="/docs/Logo/Scotts-Miracle-Gro-Logo.zip">&bull; Download Scotts Miracle-Gro Logos</option>
                                <optgroup label="--Collateral (catalogs)--" style="color:#999;">
                                    <option value="/archive/my-tools/SMG-Catalog.pdf" style="color:#666;">&bull; Scotts and Miracle Gro Catalog</option>
                                    <option value="/archive/my-tools/SMG-Assortment-Catalog-No-Pricing.pdf" style="color:#666;">&bull; SMG Assortment Catalog</option>
                                </optgroup>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/cat-logo.png"
                                alt="my-tools-icon"

                                width="100px"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">Cat</option>
                                <option value="/docs/Logo/CAT-Logo.zip">&bull; Download Cat Logos</option>
                                <optgroup label="--Collateral (catalogs)--" style="color:#999;">
                                    <option
                                        value="/docs/catalogs/CAT/CAT-Catalog.pdf?v=2025"
                                        style="color:#666;"
                                        >&bull; CAT Catalog</option
                                    >
                                </optgroup>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/John_Deere_logo.png"
                                alt="my-tools-icon"
                                width="100px"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;">John Deere</option>
                                <option value="/docs/Logo/JohnDeere-Logo.zip">&bull; Download John Deere Logos</option>
                                <optgroup label="--Collateral (catalogs)--" style="color:#999;">
                                    <option value="/docs/Catalogs/JD/JD-Catalog.pdf"
                                        style="color:#666;"
                                        >&bull; John Deere Catalog</option
                                    >
                                </optgroup>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/Grippaz-Logo-Black.png"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-Grippaz-Brochure-022022.pdf"
                                    >&bull; Brochure: Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/Grippaz-Extended-Use-Gloves-Brochure.pdf"
                                    >&bull; Brochure: Extended Use Gloves - Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/Grippaz-Industrial-Case-Study.pdf"
                                    >&bull; Industrial Case Study: Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/Grippaz-Infographic.pdf"
                                    >&bull; Infographic: Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-Extended-Use-Gloves-Brochure--022022.pdf"
                                    >&bull; Blog: Extended Use Nitrile Gloves - Grippaz</option
                                >
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/ATG_Logo_color.jpg"
                                width="100px"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >ATG</option
                                >
                                <option
                                    value="/archive/my-tools/ATG_Logo_color.jpg"
                                    >&bull; Download ATG Logos</option
                                >
                            </admin-select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/PUMA-Safety-Logo.png"
                                width="100px"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >PUMA Safety</option
                                >
                                <option
                                    value="/archive/my-tools/Puma-Safety-Catalog-US--ALL-digital-2025.pdf"
                                    >&bull; Puma Safety Catalog</option
                                >
                                <option
                                    value="/archive/my-tools/2025-PUMA-Seasonal-Catalog_v6.pdf"
                                    >&bull; 2025 Puma Seasonal Catalog</option
                                >
                                <option
                                    value="/archive/my-tools/2024-PUMA-MOTION-PWR-Sellsheet_US.pdf"
                                    >&bull; 2024 Puma Motion PWR Sellsheet</option
                                >
                                <option
                                    value="/archive/my-tools/2024-PUMA-NEWS-Sellsheet_US.pdf"
                                    >&bull; 2024 Puma News Sellsheet</option
                                >
                            </admin-select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src="/archive/my-tools/North-by-PIP-Logo_Color.png"
                                width="100px"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >North</option
                                >
                                <option
                                    value="/docs/Logo/North-Logo.zip"
                                    >&bull; Download North Logos</option
                                >
                            </admin-select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src="/archive/my-tools/Howard-Leight-by-PIP-Logo_Color.png"
                                width="100px"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Howard Leight</option
                                >
                                <option
                                    value="/docs/Logo/Howard-Leight-Logo.zip"
                                    >&bull; Download Howard Leight Logos</option
                                >
                            </admin-select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src="/archive/my-tools/UVEX-by-PIP-Logo_Color.png"
                                width="100px"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Uvex</option
                                >
                                <option
                                    value="/docs/Logo/Uvex-Logo.zip"
                                    >&bull; Download Uvex Logos</option
                                >
                            </admin-select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src="/archive/my-tools/Miller-by-PIP-Logo_K.png"
                                width="100px"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Miller</option
                                >
                                <option
                                    value="/docs/Logo/Miller-Logo.zip"
                                    >&bull; Download Miller Logos</option
                                >
                            </admin-select>
                        </form>
                    </li>

                </ul>
                <br />
                <br />
                <h3>MARKETING DOCUMENTS</h3>
                <ul>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-media-add.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Tradeshow Docs</option
                                >
                                <option
                                    value="/docs/Tradeshow/Follow-Up-Form.pdf"
                                    >&bull; Follow Up Form</option
                                >
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-presentation.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Training</option
                                >
                                <option
                                    value="/docs/Training/Eye-and-Face-Protection.pptx"
                                    >&bull; Eye and Face Protection</option
                                >
                                <option
                                    value="/docs/Training/Fall-Protection.pptx"
                                    >&bull; Fall Protection</option
                                >
                                <option
                                    value="/docs/Training/Gloves-in-the-Grocery.pdf"
                                    >&bull; Gloves in the Grocery</option
                                >
                                <option
                                    value="/docs/Training/Hand-Protection-Basics-GP-Chem.pptx"
                                    >&bull; Hand Protection Basics GP Chem</option
                                >
                                <option
                                    value="/docs/Training/Head-Protection-and-Liners.pptx"
                                    >&bull; Head Protection and Liners</option
                                >
                                <option
                                    value="/docs/Training/Hearing-Protection-Long-Version.pptx"
                                    >&bull; Hearing Protection Long Version</option
                                >
                                <option
                                    value="/docs/Training/High-Visibility-Garments-Cold-and-Heat-Stress.pptx"
                                    >&bull; High Visibility Garments Cold and Heat
                                    Stress</option
                                >
                                <option
                                    value="/docs/Training/Respiratory-Protection-Long-Version.pptx"
                                    >&bull; Respiratory Protection Long Version</option
                                >
                                <option
                                    value="/docs/Training/Sales-Meeting.pptx"
                                    >&bull; Sales Meeting</option
                                >
                            </admin-select>
                        </form>
                    </li>
                </ul>
                <br />
                <br />
                <h3>SALES DOCUMENTS</h3>
                <ul>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-price-list.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Price List</option
                                    ><option value="/docs/PriceList/Puma-Safety-Price-List_Spring-2026.pdf">&bull; 2026 PUMA Price List</option>
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-internal.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Internal Docs</option
                                >
                                <option
                                    value="/docs/InternalDocs/Inventory-forecast-template.xlsx"
                                    >&bull; Inventory Forecast Template</option
                                >
                            </admin-select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-new-account.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >New Account Setup</option
                                >
                                <option
                                    value="/docs/NewAccount/New-Accounts-Form-June2025.xlsx"
                                    >&bull; New Accounts/Ship To Form (06/25)</option
                                >
                                <option
                                    value="/docs/NewAccount/PIP-Global-Safety-Credit-Application-Internet-Link-Oct-2025.pdf"
                                    >&bull; PIP Global Safety Credit Application Internet Link</option
                                >
                                <option
                                    value="/docs/NewAccount/Billtrust-Online-Credit-Application-Process-Oct-2025.pdf"
                                    >&bull; Billtrust Online Credit Application Process</option
                                >
                                <option
                                    value="/docs/NewAccount/NEW-CUSTOMER-INACTIVE-CUSTOMER-PROCESS-FOR-SALES-WCPG-RETAIL.pdf"
                                    >&bull; New/Inactive Customer Process for Sales</option
                                >
                                <option
                                    value="/docs/NewAccount/W9-WCPG-dba-PIP-Global-Safety-2026.pdf"
                                    >&bull; W9 - DBA PIP Global Safety</option
                                >
                                <option
                                    value="/docs/NewAccount/WCPG-PIP-Global-Safety-Remittance-Banking-Instructions.pdf"
                                    >&bull; WCPG PIP Global Safety Remittance Banking Instructions</option
                                >
                                <!-- <option
                                    value="/docs/NewAccount/West-Chester-part-of-PIP-family-Credit-Application.docx"
                                    >&bull; PIP Global Safety Credit Application Internet Link</option
                                > -->
                                <!-- <option
                                    value="/docs/NewAccount/West-Chester-part-of-PIP-family-Credit-Application.docx"
                                    >&bull; Credit Application Form</option
                                >
                                <option
                                    value="/docs/NewAccount/New-Customer-Inactive-Customer-Process-for-Sales-WCPG.docx"
                                    >&bull; New/Inactive Customer Process</option
                                > -->
                                <option
                                    value="/docs/NewAccount/RetailCustomerProgram.pdf"
                                    >&bull; Retail Customer Program</option
                                >
                            </admin-select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-calendar.gif"
                                alt="my-tools-icon" width="50"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Calendars</option
                                >
                                <option
                                    value="https://pipusa.sharepoint.com/sites/WCPG/Lists/Retail%20Events%20Calendar/calendar.aspx"
                                    target="_blank"
                                    >&bull; View</option
                                >
                            </admin-select>
                        </form>
                    </li>


                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-agent.gif"
                                alt="my-tools-icon" width="50"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Rep Agent Docs</option
                                >
                                <option
                                    value="/docs/RepAgent/New-Agent-Form.pdf"
                                    >&bull; New Agent Form</option
                                >
                                <option
                                    value="/docs/RepAgent/Safety-Works-Inventory-Forecast-Template.xlsx"
                                    >&bull; Inventory Forecast Template</option
                                >
                                <option
                                    value="/docs/RepAgent/WC-Direct-Deposit-Form.pdf"
                                    >&bull; Direct Deposit Authorization - Independent
                                    Rep</option
                                >
                                <option value="/docs/RepAgent/W-9-2018.pdf"
                                    >&bull; W-9</option
                                >
                            </admin-select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/admin-icon-3sp-online-training.gif"
                                alt="my-tools-icon" width="50" style="border:1px solid #3a3a3a; padding:3px;"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >3SP&trade; Online Training</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Online-Training-Internal-Brochure.pdf"
                                    >&bull; 3SP Online Training Internal Brochure</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Online-Training-Internal-Request-Form.pdf"
                                    >&bull; 3SP Online Training Internal Request Form</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Online-Training-External-Brochure.pdf"
                                    >&bull; 3SP Online Training External Brochure</option
                                >
                                <option value="/archive/my-tools/3SP Online Training - Customer Sign Up Process for Sales.pdf"
                                    >&bull; 3SP Online Training - Customer Sign Up Process for Sales</option
                                >
                                <option
                                    value="/archive/my-tools/3SP Online Training_Self-Serve Participants Spreadsheet.xlsx"
                                    >&bull; Online Training Self-Serve Participants Spreadsheet</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Sales-Training-Deck.pptx"
                                    >&bull; 3SP Sales Training Deck</option
                                >
                            </admin-select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/admin-icon-3SP-Assessment.jpg"
                                alt="my-tools-icon" width="50" style="border:1px solid #3a3a3a; padding:3px;"
                            />
                        </figure>
                        <form>
                            <admin-select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >3SP&trade; Assessment</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Overview---05152020.pdf"
                                    >&bull; Overview</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Letter---05152020.pdf"
                                    >&bull; Letter</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-3SP-Sample-Assessment.pdf"
                                    >&bull; Sample Assessment</option
                                >
                                <option value="/archive/my-tools/3SP-Hand-Protection-Assessment---05152020.pdf"
                                    >&bull; Hand Protection Assessment</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-3SP-Eye-Protection-Assessment-Form.pdf"
                                    >&bull; Eye Protection Assessment</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-3SP-PPE-Assessment-Form.pdf"
                                    >&bull; Facility Info Assessment</option
                                >
                            </admin-select>
                        </form>
                    </li>
                </ul>

                <br />
                <br />
                <h3>WEBSITE TOOLS</h3>
                <ul>
                    <li v-if="priceDeviationAdmins.includes(user.id) || user.user_group_id == 9 || user.user_group_id == 10">
                        <router-link :to="{ name: 'PriceWorkflowSubmission' }">
                            <figure>
                                    <img
                                        src=" /images/icons/admin-icon-dev-price-portal.gif"
                                        alt="my-tools-icon"
                                    />
                            </figure>
                            <span>Pricing Activity Workflow</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link  :to="{ name: 'vector-view' }"  >
                            <figure>
                                <img
                                    src=" /images/icons/admin-icon-upload.gif"
                                    alt="my-tools-icon"
                                />
                            </figure>
                            <span >Vector Viewer</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link  :to="{ name: 'SpecSheetDownload' }"  >
                            <figure>
                                <img
                                    src=" /images/icons/admin-icon-spec-sheet.gif"
                                    alt="my-tools-icon"
                                />
                            </figure>
                            <span >Spec Sheet Portal</span>
                        </router-link>
                    </li>
                </ul>

                <br />
                <br />
                <div v-if="user.user_group_id==8">
                    <h3>WEBSITE ADMIN TOOLS</h3>
                    <ul>
                        <li>
                            <router-link :to="{name: 'search-user'}" >
                                <figure>
                                    <img
                                        src=" /images/my-tools-icons/WCPG-Dash-Icons_0018_Group-19.png"
                                        alt="my-tools-icon"
                                    />
                                </figure>
                                <span >Edit User</span></router-link
                            >
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
h3 {
    text-transform: uppercase;
    font: 16px/1.1 "acumin-pro", Helvetica, Arial, sans-serif;
    margin-bottom: 1rem;
    font-size: 1rem;
    font-weight: 600;
    padding-bottom: 0.3rem;
    border-bottom: dotted 1px #ccc;
}
select {
    font-family: "acumin-pro-condensed", Helvetica, Arial, sans-serif;
    color: #666666;
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    width: 100%;
    background: white;
}
.brand{
    figure{
        padding:0;
        margin:0;
        height:100px;
        display:flex;
        justify-content: center;
        align-items:center;
        img{
            height:auto;
        }

    }
}
</style>
<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            user: state => state.user,
            priceDeviationAdmins: state => state.priceDeviationAdmins
        })
    },
    methods: {
        onChange(event) {
            window.open(event.target.value);
        }
    }
};
</script>
